export const featuresData = [
  {
    id: 1,
    title: "AI CyberGPT Chat",
    description: "Natural-language investigation assistant powered by advanced AI models for intuitive threat analysis",
    icon: "bot"
  },
  {
    id: 2,
    title: "IP/URL/Domain Intelligence",
    description: "Integrates VirusTotal, PDNS, RDAP, and AbuseIPDB for comprehensive threat intelligence",
    icon: "globe"
  },
  {
    id: 3,
    title: "Graph Visualization",
    description: "Neo4j-powered threat infrastructure mapping for visual relationship analysis",
    icon: "network"
  },
  {
    id: 4,
    title: "Agentic AI",
    description: "Auto-correlation, intelligent report drafting, and risk scoring with minimal human intervention",
    icon: "brain"
  },
  {
    id: 5,
    title: "ML-Powered Risk Engine",
    description: "Predicts malicious probability using advanced machine learning algorithms",
    icon: "shield-alert"
  },
  {
    id: 6,
    title: "Evidence Reports",
    description: "Exportable PDF reports for investigators with comprehensive findings and evidence",
    icon: "file-text"
  }
];

export const mockChatMessages = [
  {
    id: 1,
    role: "assistant",
    content: "Welcome to RakshakAI. I'm your AI-powered cyber investigator. How can I assist you today?",
    timestamp: new Date().toISOString()
  },
  {
    id: 2,
    role: "user",
    content: "Analyze this IP address: 192.168.1.100",
    timestamp: new Date().toISOString()
  },
  {
    id: 3,
    role: "assistant",
    content: "Analyzing IP 192.168.1.100...\n\n**Intelligence Summary:**\n- IP Type: Private IPv4\n- Location: Internal Network\n- Risk Score: Low (2/10)\n- Reputation: Clean\n- Known Threats: None detected\n\nWould you like me to perform a deeper scan or check for related domains?",
    timestamp: new Date().toISOString()
  }
];

export const investigationOptions = [
  { id: 1, label: "New Investigation", icon: "plus" },
  { id: 2, label: "IP Scan", icon: "server" },
  { id: 3, label: "URL Scan", icon: "link" },
  { id: 4, label: "Message Analysis", icon: "message-square" },
  { id: 5, label: "Threat Graph", icon: "git-branch" },
  { id: 6, label: "Reports", icon: "file-text" }
];